export default "__VITE_ASSET__bLj8JZWx__"